import { DBO_TM, DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';
import React, { useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import { useTableData } from './hooks/useTableData';
import { Segment, Bubble } from 'tea-component';
import { ACCOUNT_DATA_SHOW } from '../../../constants';
import TableCommonHook from '@op/components/TableCommonHook';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import ChannelLabel, { ChannelIconType } from '@op/components/ChannelLabel';

import './index.scss';
import AccountSelect from '../AccountSelect';
import { gameInfoType } from '@op/types/common';
import { AccountOption } from '../../utils';
import ChannelAccountItem from '../AccountSelect/ChannelAccountItem';
import SvgIcon from '@home/components/SvgIcon';

export default function DataPerformance({
  gameInfo,
  filter,
  accountFilterOptions,
  defaultSelectAccount,
}: {
  gameInfo: gameInfoType;
  filter: any;
  accountFilterOptions: AccountOption[];
  defaultSelectAccount: string[];
}) {
  const { formatMessage } = useLanguage();

  // 渠道Tab列表
  const channelShareTab: () => {
    text: string | any;
    value: any;
  }[] = () => {
    const tab: { text?: string; value: ChannelIconType | 'total' }[] = [
      { text: 'Total', value: 'total' },
      { value: 'youtube' },
      { value: 'tiktok' },
      { value: 'instagram' },
      { value: 'twitter' },
      { value: 'facebook' },
    ];
    return tab.map((item) => {
      return {
        text: (
          <div className="dbo-inlineflex">
            {item.text ? (
              <span>{formatMessage({ id: item.text })}</span>
            ) : (
              <ChannelLabel
                iconStyle={{ width: 16, height: 16, marginRight: 4 }}
                channel_name={item.value as ChannelIconType}
              ></ChannelLabel>
            )}
          </div>
        ),
        value: item.value,
      };
    });
  };

  // 获取表单数据
  const {
    loading,
    data,
    sortBy,
    changeSortBy,
    changePageInfo,
    pageInfo,
    total,
    setSelectedAccounts,
    selectAccounts,
    setChannel,
    channel,
    timeObj,
    gotoFeeds,
    download,
  } = useTableData({
    filter,
    defaultSelectAccount,
  });

  // 表格头
  const { columns, sortList } = useMemo(() => {
    const list: any[] = [
      {
        key: 'account',
        header: formatMessage('Account'),
        width: 244,
        fixed: 'left',
        render: (record: any) => {
          return (
            <div className="dbo-account-DataPerformance-tableHead">
              <ChannelAccountItem
                item={{ ...record, text: record.account_display_name }}
              ></ChannelAccountItem>
              <Bubble
                arrowPointAtCenter
                content={formatMessage('View Comment Details')}
              >
                <div
                  className="dbo-account-DataPerformance-Icon"
                  onClick={() => gotoFeeds(record)}
                >
                  <SvgIcon type="view-details-icon" />
                </div>
              </Bubble>
            </div>
          );
        },
      },
    ];
    const sorts: Array<string> = [];

    ACCOUNT_DATA_SHOW.forEach(
      ({
        text,
        key,
        width = 190,
        format = (value) => DBO_V.reviews(value),
      }) => {
        list.push({
          key,
          header: formatMessage(text),
          width,
          align: 'right',
          render: (record: any) => {
            const percentageKey = `${key}_qoq`;
            const oldKey = `${key}_old`;
            return (
              <div className="dbo-value">
                {format(record?.[key])}
                <RingRatioBubble
                  {...timeObj}
                  oldValue={record?.[oldKey]}
                  newValue={record?.[key]}
                  formateValue={(value) => format(value)}
                  formateDate={DBO_TM.formatFunc('weekly')}
                >
                  <PercentageItem
                    percentage={record?.[percentageKey]}
                  ></PercentageItem>
                </RingRatioBubble>
              </div>
            );
          },
        });

        sorts.push(key);
      },
    );

    return { columns: list, sortList: sorts };
  }, [formatMessage, timeObj]);

  return (
    <CardCommon
      title={formatMessage('Official Account Data Performance')}
      hasDownload
      className="dbo-data-performance-wrapper"
      handleDownloadOnClick={() => download()}
    >
      {/* 渠道Tab、官号筛选器 */}
      <div className="dbo-account-DataPerformance-filter">
        <Segment
          className="tea-segment segment-font12"
          value={channel}
          onChange={(value) => {
            setChannel(value);
          }}
          options={channelShareTab()}
        />
        <div className="dbo-account-DataPerformance-accountSelect">
          <AccountSelect
            options={accountFilterOptions}
            gameInfo={gameInfo}
            defaultValue={selectAccounts}
            onClose={(value) => setSelectedAccounts(value)} 
          ></AccountSelect>
        </div>
      </div>

      {/* 表单主体 */}
      <TableCommonHook
        // recordKey={'key'}
        records={data}
        loading={loading}
        total={total}
        columns={columns}
        pageInfo={pageInfo}
        setPageInfo={changePageInfo}
        hasPageable
        bordered="all"
        sortInfo={[sortBy, changeSortBy]}
        maxHeight={670}
        minWidth={1350}
        sortColumns={sortList}
      ></TableCommonHook>
    </CardCommon>
  );
}
